import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus, { ElMessageBox } from 'element-plus'
import { enableMessageBoxDragging } from './utils/draggableMessageBox'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import './styles/index.scss'

const app = createApp(App)

app.use(store)
app.use(router)
enableMessageBoxDragging(ElMessageBox)
app.use(ElementPlus, { dialog: { draggable: true } })

app.mount('#app')
